var compareVersion = require('./compare-version');

module.exports = function () {
    var userAgent = ICF.Utils.GetUserAgent();
    var match = userAgent.match(/ipod.+?os (\d+)/);
    return !!match && compareVersion(match[1], range);
};